module.exports = __webpack_public_path__ + "img/account-m5.a0ee2941.png";